import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJamesonComponent } from './simple-icons-jameson.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJamesonComponent ],
    exports:      [ SimpleIconsJamesonComponent ],
    bootstrap:    []
})
export class SimpleIconsJamesonModule {}
